/* ----------------- Types --------------- */
import type { Confidence } from "@memorang/types";
import { Box, Button, useDevice } from "@memorang/ui";
import { useTranslation } from "react-i18next";
import { useAIFeedback } from "../hooks/useAIFeedback";

type Props = {
	onConfidenceProvided: (c: Confidence) => void;
	onAiFeedbackProvided: (confidence: Confidence) => void;
};
const SubmitAnswerAIFeedbackButton = ({
	onConfidenceProvided,
	onAiFeedbackProvided,
}: Props) => {
	const { generateExplanation } = useAIFeedback();

	const handleSubmitResponse = async (confidence: Confidence) => {
		onConfidenceProvided(confidence);
		await generateExplanation(() => onAiFeedbackProvided(confidence));
	};

	const { t } = useTranslation();

	const { isMobile } = useDevice();

	return (
		<Box
			style={{
				maxWidth: isMobile ? "100%" : 400,
				width: "100%",
				alignSelf: "center",
			}}
		>
			<Button
				mode="contained"
				onPress={() => {
					handleSubmitResponse(50);
				}}
			>
				{t("common.submitResponse")}
			</Button>
		</Box>
	);
};

export default SubmitAnswerAIFeedbackButton;
